import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trangle-round",
  "use": "icon-trangle-round-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trangle-round\"><path d=\"M716.8 117.029L1170.286 1024H0l453.486-906.971c29.257-73.143 131.657-102.4 190.171-58.515 29.257 0 58.514 29.257 73.143 58.515z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol